import { render } from "./SetLoader.vue?vue&type=template&id=3b9567cf"
import script from "./SetLoader.vue?vue&type=script&lang=js"
export * from "./SetLoader.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__